import store from 'state'
import { DEFAULT_LOCAL_CURRENCY } from 'config/constants'
import localCurrencies from 'config/constants/localCurrencies'

/**
 * Function to return symbol of a fiat currency
 */
const getFiatSymbol = (localCurrency?: string): string => {
  const state = store.getState()
  let currency: string
  if (localCurrency && Object.keys(localCurrencies).includes(localCurrency.toUpperCase())) {
    currency = localCurrency.toUpperCase()
  } else {
    currency = state.user.localCurrency ?? DEFAULT_LOCAL_CURRENCY
  }
  return localCurrencies[currency]?.symbol ?? localCurrencies[DEFAULT_LOCAL_CURRENCY].symbol
}

export default getFiatSymbol

export const getFiatCurrency = (localCurrency?: string): string => {
  const state = store.getState()
  let currency: string
  if (localCurrency && Object.keys(localCurrencies).includes(localCurrency.toUpperCase())) {
    currency = localCurrency.toUpperCase()
  } else {
    currency = state.user.localCurrency ?? DEFAULT_LOCAL_CURRENCY
  }
  return localCurrencies[currency]?.currency ?? localCurrencies[DEFAULT_LOCAL_CURRENCY].currency
}
